<template>
    <div v-if="age18" class="mb-2">
        <v-row no-gutters>
            <v-col md="12" class="pa-3">
                <WarningAlert
                  class="alertHeaderParticipant"
                >
                    <div v-if="$route.path != '/emergencyinfo'">
                      <v-expansion-panels v-model="panel" flat :color="bgAlertColor">
                        <v-expansion-panel >
                          <v-expansion-panel-header :color="bgAlertColor" class="text-customizer-accent font-weight-bold">
                          {{ $t("common.selectParticipants.title") }}
                          </v-expansion-panel-header>
                        <v-expansion-panel-content :color="bgAlertColor">
                          <p class="mb-0">{{ $t("common.selectParticipants.content_1") }}</p>
                          <p class="mb-0">{{ content2 }}</p>
                        </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </div>
                    <div v-else>
                      <v-expansion-panels v-model="panel" flat :color="bgAlertColor">
                        <v-expansion-panel >
                          <v-expansion-panel-header :color="bgAlertColor" class="text-customizer-accent font-weight-bold">
                          {{ $t("common.selectParticipants.title") }}
                          </v-expansion-panel-header>
                        <v-expansion-panel-content :color="bgAlertColor">
                          <p class="mb-0">{{ $t("common.selectParticipants.content_1") }}</p>
                        </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </div>
                </WarningAlert>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col md="6" class="pb-0 pl-2 pt-2 pr-2">
                <v-select 
                  v-model="partSelect" 
                  :items="participants" 
                  item-text="names" 
                  @change="selectParticipants" 
                  :label="$t('results.select_part_label')"
                  item-value="id" 
                  return-object 
                  :hint="$t('results.select_part')" 
                  multiple 
                  persistent-hint 
                  dense 
                  outlined
                  :no-data-text="$t('common.no_data')"
                ></v-select>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { VCol, VRow, VSelect, VExpansionPanels, VExpansionPanel, VExpansionPanelHeader, VExpansionPanelContent } from 'vuetify/lib';
import { mapState } from 'vuex';
import WarningAlert from '@/components/alert/WarningAlert.vue';

export default {
  components:{ 
        VCol, VRow, VSelect, VExpansionPanels, VExpansionPanel, VExpansionPanelHeader,
        VExpansionPanelContent, WarningAlert
  },
  props: {
        participants: Array, participant: Array
  },
  data() { 
    return {
        borderAlertColor: '',
        iconAlertColor: '',
        bgAlertColor: '',
        panel: [],
    };
  },
  computed: {
    ...mapState({
        content2(state) {
            return this.$t("common.selectParticipants.content_2", { livelapsId: state.session.userid })
        },
        user: (state) => state.session.user,
        age18: (state) => state.session.age18
    }),
    partSelect: {
        get: function(){
            return this.participant;
        },
        set: function(newValue){
            this.$emit('changeSelect', newValue)
        }   
    },
  },
  methods: {
    selectParticipants() {
        this.$emit('selectParticipants');
    }
  },
  mounted() {
    if(!this.user) {
        this.$store.dispatch('setUserAction');
    }
  },
  created(){
    this.borderAlertColor = this.$store.getters.env.get('VUE_APP_BORDER_ALERT_REGULAR');
    this.iconAlertColor = this.$store.getters.env.get('VUE_APP_ICON_ALERT_REGULAR');
    this.bgAlertColor = this.$store.getters.env.get('VUE_APP_BG_ALERT_REGULAR');
  },
  updated() {}
}
</script>

<style>
.alertHeaderParticipant .v-expansion-panel-header__icon{
  display: none;
}
.alertHeaderParticipant .v-alert__content{
    margin: -4px 0px 0px -15px !important;
}
.alertHeaderParticipant{
  padding: 8px !important;
}
.alertHeaderParticipant .v-alert__wrapper i {
    margin-top: 0.5% !important;
}
.alertHeaderParticipant .v-expansion-panel-header {
    padding: 16px 20px !important;

}
</style>